import React from "react";
import PropTypes from "prop-types";

export function Label(props) {
  return <p className={props.className}>{props.text}</p>;
}

Label.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Text to display as label
   */
  text: PropTypes.string,
};

Label.defaultProps = {
  className: "",
};
